import ReactDOM from 'react-dom/client'
import { App } from 'antd'
import './index.css'
import AppRoute from './App'
// import reportWebVitals from './reportWebVitals'
import { HashRouter } from 'react-router-dom'
import '@/utils/flexible'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <App>
    <HashRouter>
      <AppRoute message={{ maxCount: 1 }} notification={{ placement: 'bottomLeft' }} />
    </HashRouter>
  </App>

  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
